import React from 'react';
import { string, node } from 'prop-types';
import { Box } from '@mui/material';

const TabContent = ({ value, current, children }) => {
  if (value !== current) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      }}
    >
      {children}
    </Box>
  );
};

TabContent.propTypes = {
  value: string.isRequired,
  current: string.isRequired,
  children: node.isRequired,
};

export default TabContent;
